import React from 'react';
import $ from 'jquery';
import {BaseTeamsCombinations} from 'components/organisms/teams-combinations/components/base-teams-combinations';

class MobileTeamsCombinations extends BaseTeamsCombinations {
    componentDidMount() {
        $('body').scrollTop(0);
    }

    getView(params) {
        const lineupsQuantity = this.getLineupsQuantity();
        const {content, combosQuantity} = params;

        return (
            <div className="tab-content combo-summary-content">
                <div className="lineups-info-holder">
                    <ul className="lineups-info">
                        <li>
                            <strong>{combosQuantity}</strong> Teams Combo Used
                        </li>
                        <li>
                            <strong>{lineupsQuantity}</strong> Lineups
                        </li>
                    </ul>
                </div>
                <div className="players-used-table table-holder">
                    <div className="sticky-table">
                        <table className="players-table">
                            <tbody>
                                <tr>
                                    <th></th>
                                    <th>Teams</th>
                                    <th>Exp%</th>
                                    <th>Exp.max</th>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <table className="table">{content}</table>
                </div>
            </div>
        );
    }
}
export {MobileTeamsCombinations};
